var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20711 0.292893C1.81658 -0.0976311 1.18342 -0.0976311 0.792893 0.292893C0.402369 0.683417 0.402369 1.31658 0.792893 1.70711L2.20711 0.292893ZM5.5 5L4.79289 5.70711C5.18342 6.09763 5.81658 6.09763 6.20711 5.70711L5.5 5ZM10.2071 1.70711C10.5976 1.31658 10.5976 0.683417 10.2071 0.292893C9.81658 -0.0976311 9.18342 -0.0976311 8.79289 0.292893L10.2071 1.70711ZM0.792893 1.70711L4.79289 5.70711L6.20711 4.29289L2.20711 0.292893L0.792893 1.70711ZM6.20711 5.70711L10.2071 1.70711L8.79289 0.292893L4.79289 4.29289L6.20711 5.70711Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.b44d71b1.svg";
export { ForwardRef as ReactComponent };